import * as React from "react";
import "./auth.css";

interface Props {
  children?: React.ReactNode;
  /** A line under the wordmark saying what this page is for */
  intro?: React.ReactNode;
}

/** The chest, the wordmark and a paper card, for signing in and connecting the extension. */
export const AuthShell: React.FC<Props> = ({ children, intro }) => (
  <div className="auth">
    <div className="auth-column">
      <img className="auth-logo" src="/logo.webp" alt="" />
      <h1 className="auth-wordmark">StashIt</h1>
      {intro && <p className="auth-intro">{intro}</p>}
      <div className="auth-card">{children}</div>
    </div>
  </div>
);
